export default __webpack_public_path__ + "static/media/Visa.a05453b4.png";